import { utilService } from "../../../services/utilService";
import { apiServiceConstants } from "../../../constants/apiService.constants";
import { apiService } from "../../../services/apiService";

const userStatusMessage = async (params: any,selectedNetwork?:any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/profile-status-message/?reg_code=${utilService.getNetwork()}&n2n_network=${selectedNetwork?? ""}` +
        `&guid=` +
        params.guid,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userStatusMessageResp = res as any;

      const result: any = {
        isSuccess: true,
        status: userStatusMessageResp.status,
        message: userStatusMessageResp.message,
        result: userStatusMessageResp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const addUserStatusMessage = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/profile-status-message/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userStatusMessageResp = res as any;

      const result: any = {
        isSuccess: true,
        status: userStatusMessageResp.status,
        message: userStatusMessageResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const updateUserStatusMessage = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/profile-status-message/${
        params.id
      }/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.PUT,
      utilService.getDeviceType()
    )
    .then((res) => {
      const userStatusMessageResp = res as any;

      const result: any = {
        isSuccess: true,
        status: userStatusMessageResp.status,
        message: userStatusMessageResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const handleErrorResponse = () => {};

export const headerService = {
  userStatusMessage,
  addUserStatusMessage,
  updateUserStatusMessage,
  handleErrorResponse,
};
